import { useState } from 'react'
import "./style.css"
import { Alert, Button, Card, Container, Image } from 'react-bootstrap'
import { FiEdit } from 'react-icons/fi';
import { useAuth } from '../../context/auth';
import BasicSettings from './BasicSettings';
import PasswordSettings from './PasswordSettings';
import ConfirmDeleteAccount from './ConfirmDeleteAccount';
import EmailSettings from './EmailSettings';
import ProfileImageUpload from './UploadProfileImage';
import { FaUserCircle } from 'react-icons/fa';

function Account() {
        const [deleteUser, setDeleteUser] = useState(false);
        const [ploadProfileImage, setUploadProfileImage] = useState(false);
        const [error, setError] = useState("")
        const { user } = useAuth();

        const baseURL = process.env.REACT_APP_API_URL as string;
        const profileImg = user?.profileImg
        return (
                <>{user &&
                <Container style={{maxWidth:800, margin:"0 auto"}} className='my-5'>
                        {/* welcome card */}
                        <Card className="mb-4 bg-dark text-white border-secondary">
                                <Card.Body className='text-center'>
									<Button 
										variant={"outline-primary"}
										onClick={e => setUploadProfileImage(true)}
										style={{position:'absolute', top:'1em',right:'1em'}}>
										<FiEdit size={20} />
									</Button>
                                <div className="image-wrapper position-relative mb-3">
									{profileImg ? (<Image
											src={`${baseURL}${profileImg}`}
											roundedCircle
											alt="User Profile"
											width={100}
											height={100}
											className="mb-3"
									/>) : ( <FaUserCircle size={100} className="text-secondary" /> )}
                                     
                                </div>
                                <h2 className="text-white">Welcome, {user?.firstName}</h2>
                                <p className="text-light">
                                        Manage your account information, privacy, and security.
                                </p>
                                </Card.Body>
                        </Card>
                        {/* upload prfile image */}
                         <ProfileImageUpload
                                show={ploadProfileImage}
                                handleClose={() => setUploadProfileImage(false)}
                        />
                        {/* General Settings */}
                        <BasicSettings user={user} />

                        {/* Email settings */}
                        <EmailSettings user={user}/>

                        {/* update password */}
                        <PasswordSettings user={user} />
                        
                        {/* Delete account */}
                        <Card className="bg-dark text-white border-danger">
                                <Card.Body>
                                <Card.Title className="text-danger">Delete Account</Card.Title>
                                <Card.Text className="text-light">
                                        Please be warned that once you delete your team account, this action cannot be undone. 
                                        Ensure you're certain, as all organizations you own, uploaded data, 
                                        and trained agents will be permanently deleted. <br />
                                        <span className='text-danger'>This process is irreversible</span>.
                                </Card.Text>
                                {error && (
                                        <Alert variant="danger" className="mt-3 bg-danger bg-opacity-25 text-light border-danger">
                                                {error}
                                        </Alert>
                                )}
                                <Button variant="outline-danger" onClick={()=>setDeleteUser(true)}>Delete Account</Button>
                                </Card.Body>
                        </Card>
                        {
                                deleteUser && 
                                <ConfirmDeleteAccount 
                                        user={user} 
                                        cancel={setDeleteUser} 
                                        setError={setError}
                                />
                        }
                </Container>
                }</>
        )
}

export default Account